import {MakeServiceRequest, ServiceBase} from "~/services/core/serviceBase";
// @ts-ignore
import {$Fetch} from "nitropack";

export default class MailService extends ServiceBase {
    public get(data: IMailServiceData) : Promise<$Fetch> {
        return MakeServiceRequest<any>(`${this.getAPIUrl()}mail.py`, {
            method: "POST",
            body: data
        });
    }
}

export interface IMailServiceData {
    Name: string
    Tel: string
    Email: string
    Url: string
}
